import { render } from "./OrganisationDailyReport.vue?vue&type=template&id=eb508b96"
import script from "./OrganisationDailyReport.vue?vue&type=script&lang=js"
export * from "./OrganisationDailyReport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__